import { ApiConfig } from '../../Config.js';
import axios from 'axios';


var EnrollEboxCtrl = function (fn, er, values, token, ids, managerList) {

    var config = {
        headers: {
            'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
        },
    };
    var data = {

        user:sessionStorage.getItem('user'),
        name: sessionStorage.getItem('nome'),
        surname: sessionStorage.getItem('cognome'),
        telephone: sessionStorage.getItem('telefono'),
        email: sessionStorage.getItem('email'),
        flagMail: values.checked,
        fax: sessionStorage.getItem('fax'),
        description: sessionStorage.getItem('insegna'),
        managerList: managerList
    };

    axios
        .post(ApiConfig.url.ENROLL_EBOX, data, config)
        .then(function (result) {
            fn(result.data, result.status)
        })
        .catch(function (error) {
            er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
        });
}

export { EnrollEboxCtrl };